import React from 'react';
import { Card, Col, Input, Row, Table } from 'reactstrap';

import styles from './style.module.scss';

import Environment from '../../../environment/Environment';

import PageLoader from '../../../components/Common/loader/PageLoader';
import Pagination from '../../../components/Common/pagination/pagination';
import ActionCard from '../../../components/Footer/ActionCard';

import { GetPlanId, TwoDecimalPlace } from '../../../helpers/Helpers';

import { IManageProductData } from '../../../interfaces/manage-product.interface';
import { AssignPhToSku, GetManageProductList } from '../../../api-services/manage-product.api';

interface Props {
  history: any;
}

interface State {
  isLoading: boolean;
  dataSource: IManageProductData;
  phList: any[];
  skuList: any[];
  originalSkuList: any[];
  showFooter: boolean;
  search: string;
  itemsCount: number;
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  selectedPHClass: string;
}

export default class DigitalProductCatalog extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      dataSource: { columns: [], rows: [] },
      phList: [],
      skuList: [],
      originalSkuList: [],
      showFooter: false,
      search: '',
      itemsCount: 0,
      itemsPerPage: Environment.ITEMS_PER_PAGE,
      currentPage: 1,
      totalPages: 0,
      selectedPHClass: ''
    };
  }

  componentDidMount(): void {
    this.getManageProduct();
  }

  getManageProduct(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    GetManageProductList(params)
      .then((res: IManageProductData) => {
        const items = (!!res && Object.keys(res).length !== 0)
          ? {
            columns: res.columns,
            rows: res.rows.map((row) => {
              return {
                ...row,
                checked: false,
                asp: TwoDecimalPlace(row.asp),
                lqActuals$: TwoDecimalPlace(row.lq_qty_actuals),
                lyActuals$: TwoDecimalPlace(row.ly_qty_actuals),
                lyMargin$: TwoDecimalPlace(row.margin_ly),
                yMarginPer: TwoDecimalPlace(row.margin_pct_ly),
              };
            })
          }
          : { columns: [], rows: [] };

        this.setState({
          dataSource: items,
          isLoading: false
        }, () => {
          this.setState({
            phList: this.state.dataSource.rows
              .filter((row) => !row.isSku)
              .map((row) => {
                return {
                  checked: false,
                  ph: row.product_code,
                  phDescription: row.product_description,
                  sku: '',
                  skuDescription: '',
                  class: row.prod_level2_code,
                  subclass: row.prod_level3_code,
                  productType: row.prod_level4_code,
                  asp: '',
                };
              }),
            originalSkuList: this.state.dataSource.rows
              .filter((row) => row.isSku)
              .map((row) => {
                return {
                  checked: false,
                  sku: row.product_code,
                  skuDescription: row.product_description,
                  class: row.prod_level2_code,
                  subclass: row.prod_level3_code,
                  productType: row.prod_level4_code,
                  asp: row.asp,
                };
              })
          }, () => {
            this.dataInit();
          });
        });
      });
  }

  dataInit(): void {
    let items = this.state.originalSkuList;

    items = items.filter((item) => {
      let allowed = true;

      if (allowed && !!this.state.selectedPHClass) {
        allowed = item.class === this.state.selectedPHClass;
      }

      if (allowed && !!this.state.search) {
        const matches = (
          item.sku.toLocaleUpperCase() +
          item.skuDescription.toLocaleUpperCase() +
          item.class.toLocaleUpperCase() +
          item.subclass.toLocaleUpperCase() +
          item.productType.toLocaleUpperCase()
        ).match(this.state.search.toLocaleUpperCase());

        allowed = !!(matches && matches.length > 0);
      }

      return allowed;
    });

    const itemsCount = items.length;
    items = items.slice(this.state.itemsPerPage * (this.state.currentPage - 1), this.state.itemsPerPage * this.state.currentPage);

    this.setState({
      itemsCount,
      totalPages: Math.ceil(this.state.originalSkuList.length / this.state.itemsPerPage),
      skuList: items
    });
  }

  resetSelection(phIdx: number): void {
    const skuIdx = this.state.skuList.findIndex((sku) => sku.sku === this.state.phList[phIdx].sku);
    if (skuIdx > -1) {
      this.state.skuList[skuIdx].checked = false;
      this.state.skuList[skuIdx].isDisabled = false;
    }

    this.state.phList[phIdx].checked = false;
    this.state.phList[phIdx].isDisabled = false;
    this.state.phList[phIdx].sku = '';
    this.state.phList[phIdx].skuDescription = '';
    this.state.phList[phIdx].asp = '';

    this.setState({
      phList: this.state.phList,
      skuList: this.state.skuList,
      selectedPHClass: ''
    }, () => {
      this.dataInit();
    });
  }

  updateRadioBox(list: string, index: number): void {
    const isPhSelected = this.state.phList.filter((row) => row.checked && !row.isDisabled).length > 0;

    if (list === 'skuList' && isPhSelected) {
      this.state[list][index].checked = !this.state[list][index].checked;
    }

    if (list === 'phList' && !isPhSelected) {
      this.state[list][index].checked = !this.state[list][index].checked;

      this.setState({
        selectedPHClass: this.state.phList[index].class
      }, () => {
        this.dataInit();
      });
    }

    const selectedSKUIdx = this.state.skuList.findIndex((row) => row.checked && !row.isDisabled);
    const selectedPHIdx = this.state.phList.findIndex((row) => row.checked && !row.isDisabled);

    if (selectedPHIdx > -1 && selectedSKUIdx > -1) {
      this.setState({ showFooter: true });

      this.state.phList[selectedPHIdx].sku = this.state.skuList[selectedSKUIdx].sku;
      this.state.phList[selectedPHIdx].skuDescription = this.state.skuList[selectedSKUIdx].skuDescription;
      this.state.phList[selectedPHIdx].asp = this.state.skuList[selectedSKUIdx].asp;
      this.state.phList[selectedPHIdx].isDisabled = true;
      this.state.skuList[selectedSKUIdx].isDisabled = true;
    }

    this.state.phList.forEach((row) => {
      if (!row.checked) {
        row.sku = '';
        row.skuDescription = '';
        row.asp = '';
      }
    });

    if (list === 'phList') {
      this.setState({ phList: this.state[list] });
    } else {
      this.setState({ skuList: this.state[list] });
    }
  }

  assignPhToSku(): void {
    const payload = this.state.phList
      .filter((obj) => obj.checked && !!obj.sku)
      .map((obj) => {
        return {
          phCode: obj.ph,
          skuCode: obj.sku
        };
      });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.setState({ isLoading: true });

    AssignPhToSku(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            showFooter: false
          }, () => {
            this.getManageProduct();
          });
        }
      });
  }

  searchHandler(e): void {
    this.setState({
      search: e.target.value || '',
      currentPage: 1
    }, () => {
      this.dataInit();
    });
  }

  handlePageChange(pageNumber: number): void {
    this.setState({
      currentPage: pageNumber
    }, () => {
      this.dataInit();
    });
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return (
        <PageLoader
          status={this.state.isLoading}
        />
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">

          <Card className="section-header-card">
            <Row>
              <Col md={8} className="align-self-center">

                <Row className="align-items-center">
                  <Col md={6}>

                    <div className="d-flex">
                      <p className="table-title">
                        PH SKU ({this.state.phList.length})
                      </p>
                    </div>

                  </Col>
                </Row>

              </Col>
            </Row>
          </Card>

          <div className="table-responsive table-outline custom-table">
            <Table className="mb-0">
              <thead>
              <tr>
                <th style={{ width: '30px' }}/>
                <th>PH</th>
                <th>PH description</th>
                <th>SKU</th>
                <th>SKU description</th>
                <th>Class</th>
                <th>Sub Class</th>
                <th>Product Type</th>
                <th>ASP</th>
                <th/>
              </tr>
              </thead>
              <tbody>
              {
                this.state.phList.map((row, rowIdx: number) => (
                  <tr key={rowIdx}>
                    <td>
                      <Input
                        key={rowIdx}
                        type="radio"
                        checked={row.checked}
                        disabled={row.isDisabled}
                        onChange={() => this.updateRadioBox('phList', rowIdx)}
                      />
                    </td>
                    <td>{row.ph}</td>
                    <td>{row.phDescription}</td>
                    <td>{row.sku}</td>
                    <td>{row.skuDescription}</td>
                    <td>{row.class}</td>
                    <td>{row.subclass}</td>
                    <td>{row.productType}</td>
                    <td>{row.asp}</td>
                    <td className="text-center">
                      <i className="mdi mdi-reload font-size-18 cursor-pointer"
                         onClick={() => this.resetSelection(rowIdx)}
                      />
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </Table>
          </div>

          <Card className="section-header-card">
            <Row>
              <Col md={8} className="align-self-center">

                <Row className="align-items-center">
                  <Col md={4}>

                    <div className="d-flex">
                      <p className="table-title">
                        Digital product catalogue
                      </p>
                    </div>

                  </Col>

                  <Col md={8}>

                    <div className={styles['search-input-container']}>
                      <input
                        type="text"
                        className={styles['search-input']}
                        onChange={(e) => this.searchHandler(e)}
                      />
                      <i className={`ri-search-line ${styles['search-icon']}`}/>
                    </div>

                  </Col>
                </Row>

              </Col>
            </Row>
          </Card>

          <div className="table-responsive table-outline custom-table">
            <Table className="mb-0">
              <thead>
              <tr>
                <th style={{ width: '30px' }}/>
                <th>SKU</th>
                <th>SKU description</th>
                <th>Class</th>
                <th>Sub Class</th>
                <th>Product Type</th>
                <th>ASP</th>
              </tr>
              </thead>
              <tbody>
              {
                this.state.skuList.map((row, rowIdx: number) => (
                  <tr key={rowIdx}>
                    <td>
                      <Input
                        key={rowIdx}
                        type="radio"
                        checked={row.checked}
                        disabled={row.isDisabled}
                        onChange={() => this.updateRadioBox('skuList', rowIdx)}
                      />
                    </td>
                    <td>{row.sku}</td>
                    <td>{row.skuDescription}</td>
                    <td>{row.class}</td>
                    <td>{row.subclass}</td>
                    <td>{row.productType}</td>
                    <td>{row.asp}</td>
                  </tr>
                ))
              }
              </tbody>
            </Table>
          </div>

          <Row>
            <Col md={12}>
              <Pagination
                currentPage={this.state.currentPage}
                totalCount={this.state.itemsCount}
                pageSize={this.state.itemsPerPage}
                onPageChange={(page) => this.handlePageChange(page)}
              />
            </Col>
          </Row>

        </div>

        {
          this.state.showFooter &&
          <ActionCard
            onCancel={() => {
              this.setState({ showFooter: false });
              this.props.history.replace('/manage-single-select-product');
            }}
            onSave={() => this.assignPhToSku()}
          />
        }
      </React.Fragment>
    );
  }
}
